// 公開フォーム（gift.nayu.site/f/:token）の静的な見本。報酬額・料率は出さない。
// 実フォームの入力項目（お名前・郵便番号・ご住所・お電話番号）に合わせる。デザインにあった「配達希望日時」は実フォームに無いため出さない。
import { GfTag } from "../../ui/GfUi";

const FIELDS: Array<{ label: string; placeholder: string }> = [
  { label: "お届け先のお名前（宅配便の宛名）", placeholder: "例）山田 花子" },
  { label: "郵便番号", placeholder: "123-4567" },
  { label: "ご住所", placeholder: "都道府県から建物名・部屋番号まで" },
  { label: "お電話番号（配送連絡用）", placeholder: "配送連絡用の電話番号" },
];

export function FormPreview({ subtitle }: { subtitle: string }) {
  return (
    <>
      <div className="gf-form-head">
        <span className="gf-form-logo">STOQ</span>
        <span className="gf-form-title">ギフトのお届け先を入力してください</span>
        <span className="gf-note">{subtitle}</span>
      </div>
      <div>
        <GfTag tone="muted">見本（実際の入力画面は本人に送るURLで開きます）</GfTag>
      </div>
      {FIELDS.map((f) => (
        <div className="gf-fake-field" key={f.label}>
          {f.label}
          <span className="gf-fake-input">{f.placeholder}</span>
        </div>
      ))}
      <div className="gf-fake-cta" aria-hidden>
        この住所で送信
      </div>
      <span className="gf-form-fine">ご入力いただいた情報は商品の発送のみに使用します。</span>
    </>
  );
}
